import { useDispatch } from 'react-redux';

import { getMembershipId } from '@e180/domain/lib/membership/util';

import useMembership from 'src/shared/domain/membership/hook/useMembership';
import useEventListener from 'src/shared/app/base/component/hook/useEventListener';
import { fetchOauthStatus } from 'src/shared/domain/membership/action/membershipActions';

export default function useOauthMessages() {
  const membership = useMembership();
  const dispatch = useDispatch();

  const handleMessageWindow = ({ data, source }) => {
    console.log('Received message: ', data);
    if (data.type === 'oauth' && data.action === 'oauth-redirect') {
      dispatch(fetchOauthStatus(getMembershipId(membership)))
        .then(() => {
          if (source) {
            source.close();
          }
        })
        .catch((e) => {
          throw e;
        });
    }
  };

  useEventListener('message', handleMessageWindow);
}
